/* tslint:disable */
/* eslint-disable */
/**
 * WeWalk API V2.0
 * Backend service for WeWALK Mobile Applications, written in **TypeScript** and runs on **NodeJS**. Using **MongoDB** for database, **mongoose** for ORM, **Redis Cache** for caching auth tokens. In cloud, runs in Azure App Services (wewalk-backend-v2). For cloud database, it uses MongoDB inside Azure Cosmos DB. For passwordless authentication, Firebase Authentication is used, other than that, users can use email-password sign-in as well. Transportation services are fed by [Azure Maps Mobility Services](https://docs.microsoft.com/en-us/rest/api/maps/mobility) [RAW JSON](/api/v2/documentation) - [Swagger Editor](https://editor.swagger.io) <br><br> Production Service Health: <img src='https://dev.azure.com/wewalksmartcane/wewalk-api-v2/_apis/build/status/wewalk-api-v2-CI'/> <br><br>Test Service Health: <img src='https://dev.azure.com/wewalksmartcane/wewalk-api-v2/_apis/build/status/wewalk-api-v2-CI-staging'/>
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { EmptyRequest } from '../models';
import { ErrorModelResponse } from '../models';
import { GamificationIncreasePointRequest } from '../models';
import { GamificationTasksResponse } from '../models';
import { LeaderboardResponse } from '../models';
import { ObjectivesResponse } from '../models';
import { UsersGamificationTasksResponse } from '../models';
/**
 * TasksApi - axios parameter creator
 * @export
 */
export const TasksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all tasks of gamification
         * @param {EmptyRequest} body Empty request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tasksAllPost: async (body: EmptyRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling tasksAllPost.');
            }
            const localVarPath = `/tasks/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Increase user point based on the taskid sent in request body
         * @param {GamificationIncreasePointRequest} body Empty request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tasksIncreasePointPost: async (body: GamificationIncreasePointRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling tasksIncreasePointPost.');
            }
            const localVarPath = `/tasks/increasePoint`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get leaderboard
         * @param {EmptyRequest} body Empty request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tasksLeaderboardPost: async (body: EmptyRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling tasksLeaderboardPost.');
            }
            const localVarPath = `/tasks/leaderboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get objectives
         * @param {EmptyRequest} body Empty request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tasksObjectivesPost: async (body: EmptyRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling tasksObjectivesPost.');
            }
            const localVarPath = `/tasks/objectives`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all gamification tasks of user
         * @param {EmptyRequest} body Empty request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tasksUserTasksPost: async (body: EmptyRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling tasksUserTasksPost.');
            }
            const localVarPath = `/tasks/userTasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TasksApi - functional programming interface
 * @export
 */
export const TasksApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all tasks of gamification
         * @param {EmptyRequest} body Empty request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tasksAllPost(body: EmptyRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GamificationTasksResponse>> {
            const localVarAxiosArgs = await TasksApiAxiosParamCreator(configuration).tasksAllPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Increase user point based on the taskid sent in request body
         * @param {GamificationIncreasePointRequest} body Empty request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tasksIncreasePointPost(body: GamificationIncreasePointRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsersGamificationTasksResponse>> {
            const localVarAxiosArgs = await TasksApiAxiosParamCreator(configuration).tasksIncreasePointPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get leaderboard
         * @param {EmptyRequest} body Empty request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tasksLeaderboardPost(body: EmptyRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeaderboardResponse>> {
            const localVarAxiosArgs = await TasksApiAxiosParamCreator(configuration).tasksLeaderboardPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get objectives
         * @param {EmptyRequest} body Empty request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tasksObjectivesPost(body: EmptyRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectivesResponse>> {
            const localVarAxiosArgs = await TasksApiAxiosParamCreator(configuration).tasksObjectivesPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get all gamification tasks of user
         * @param {EmptyRequest} body Empty request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tasksUserTasksPost(body: EmptyRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsersGamificationTasksResponse>> {
            const localVarAxiosArgs = await TasksApiAxiosParamCreator(configuration).tasksUserTasksPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TasksApi - factory interface
 * @export
 */
export const TasksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get all tasks of gamification
         * @param {EmptyRequest} body Empty request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tasksAllPost(body: EmptyRequest, options?: any): AxiosPromise<GamificationTasksResponse> {
            return TasksApiFp(configuration).tasksAllPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Increase user point based on the taskid sent in request body
         * @param {GamificationIncreasePointRequest} body Empty request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tasksIncreasePointPost(body: GamificationIncreasePointRequest, options?: any): AxiosPromise<UsersGamificationTasksResponse> {
            return TasksApiFp(configuration).tasksIncreasePointPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get leaderboard
         * @param {EmptyRequest} body Empty request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tasksLeaderboardPost(body: EmptyRequest, options?: any): AxiosPromise<LeaderboardResponse> {
            return TasksApiFp(configuration).tasksLeaderboardPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get objectives
         * @param {EmptyRequest} body Empty request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tasksObjectivesPost(body: EmptyRequest, options?: any): AxiosPromise<ObjectivesResponse> {
            return TasksApiFp(configuration).tasksObjectivesPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all gamification tasks of user
         * @param {EmptyRequest} body Empty request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tasksUserTasksPost(body: EmptyRequest, options?: any): AxiosPromise<UsersGamificationTasksResponse> {
            return TasksApiFp(configuration).tasksUserTasksPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TasksApi - object-oriented interface
 * @export
 * @class TasksApi
 * @extends {BaseAPI}
 */
export class TasksApi extends BaseAPI {
    /**
     * 
     * @summary Get all tasks of gamification
     * @param {EmptyRequest} body Empty request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public tasksAllPost(body: EmptyRequest, options?: any) {
        return TasksApiFp(this.configuration).tasksAllPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Increase user point based on the taskid sent in request body
     * @param {GamificationIncreasePointRequest} body Empty request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public tasksIncreasePointPost(body: GamificationIncreasePointRequest, options?: any) {
        return TasksApiFp(this.configuration).tasksIncreasePointPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Get leaderboard
     * @param {EmptyRequest} body Empty request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public tasksLeaderboardPost(body: EmptyRequest, options?: any) {
        return TasksApiFp(this.configuration).tasksLeaderboardPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Get objectives
     * @param {EmptyRequest} body Empty request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public tasksObjectivesPost(body: EmptyRequest, options?: any) {
        return TasksApiFp(this.configuration).tasksObjectivesPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Get all gamification tasks of user
     * @param {EmptyRequest} body Empty request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public tasksUserTasksPost(body: EmptyRequest, options?: any) {
        return TasksApiFp(this.configuration).tasksUserTasksPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
